import Api from "./Api";
import Utils from "../utilities/Utils";
import { IncomingSelfBillingOrder } from "../types";
import SearchHelper from "../helpers/SearchHelper";

export default class IncomingSelfBillingOrdersController extends Api {
  static getIncomingSelfBillingOrders(params: object) {
    return fetch(
      `/api/incoming_self_billing_orders?${SearchHelper.getQueryString(
        params,
      )}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      },
    ).then((res) => res.json());
  }

  static update(incomingSelfBillingOrder: IncomingSelfBillingOrder) {
    return fetch(
      `/api/incoming_self_billing_orders/${incomingSelfBillingOrder.id}`,
      {
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
        body: JSON.stringify({
          incoming_self_billing_order: incomingSelfBillingOrder,
        }),
      },
    ).then((res) => res.json());
  }

  static delete(id: string) {
    return fetch(`/api/incoming_self_billing_orders/${id}`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static getForm(id?: string) {
    const params = { id: id };

    return fetch(
      `/api/incoming_self_billing_orders/form?${Utils.encodeQueryData(params)}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.token,
        },
        credentials: "same-origin",
      },
    ).then((res) => res.json());
  }
}
